module.exports = __webpack_public_path__ + "static/media/logo2.8d548b48.svg";